(() => {
  if (customElements.get('vertical-videos')) {
    return;
  }

  class Carousel extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;
      this.cardsSize = this.dataset.cardsSize || 'default';
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.breakpoints = {
        desktop: 990
      };
    }

    connectedCallback() {
      this.initSwiper();
      this.toggleSwiperHandler();
      window.addEventListener('resize', debounce(this.toggleSwiperHandler.bind(this), 500));
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.carousel__slider');

      const swiperNext = this.querySelector('.carousel__control-next');
      const swiperPrev = this.querySelector('.carousel__control-prev');

      const sizeCardSettings = {
        default: {
          slidesPerView: 1.1,
          spaceBetween: 24,
          breakpoints: {
            480: {
              slidesPerView: 1.6,
            },
            768: {
              slidesPerView: 2.4,
            },
            [this.breakpoints.desktop]: {
              slidesPerView: 3,
            },
          },
        },
        large: {
          slidesPerView: 1.1,
          breakpoints: {
            480: {
              slidesPerView: 1.4,
            },
            768: {
              slidesPerView: 2,
            },
            [this.breakpoints.desktop]: {
              slidesPerView: 2.6,
            },
          },
        },
      };


      if (!swiperContainer) return;

      const mainSettings = {
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        speed: 300,
        ...sizeCardSettings[this.cardsSize]
      };

      this.swiper = new Swiper(swiperContainer, mainSettings);
    }

    toggleSwiperHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSwiper(window.innerWidth >= this.breakpoints.desktop);
      } catch(e) {}
    }

    toggleSwiper(destroy) {
      if (destroy) {
        this.swiper.destroy(true, true);
      } else {
        this.swiper = new Swiper(swiperContainer, mainSettings);
      }
    }
  }

  customElements.define('vertical-videos', Carousel);
})();

function setVideoPlay() {
  const videoWrappers = document.querySelectorAll('vertical-videos .uploaded-video');
  
  videoWrappers.forEach(videoWrapper => {
    videoWrapper.addEventListener('click', function() {
      const video = videoWrapper.querySelector('video');
      
      if (video.paused) {
        video.play();
        videoWrapper.classList.add('active');
      } else {
        video.pause();
        videoWrapper.classList.remove('active');
      }
      
      videoWrappers.forEach(videoWrapperToPause => {
        const videoToPause = videoWrapperToPause.querySelector('video');
        if (videoToPause != video) {
          videoToPause.pause();
          videoWrapperToPause.classList.remove('active');
        }
      });
    });
  });
}
setVideoPlay();